// extracted by mini-css-extract-plugin
export var featureBox = "index-module--featureBox--CfvMh";
export var featureButton = "index-module--featureButton--xaTIr";
export var featureTitle = "index-module--featureTitle--l1nJt";
export var featureboxIcon = "index-module--featureboxIcon--Q1leL";